<template>
  <v-row class="ma-0">
    <v-col
      v-if="!formModel.viewMode"
      cols="12"
    >
      <div
        class="dropzone-container"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
      >
        <input
          id="attachment-file-input"
          ref="attachmentFileInput"
          type="file"
          :accept="acceptedTypes"
          :disabled="formModel.viewMode"
          @change="inputFileChangeHandler"
        >
        <label
          for="attachment-file-input"
          class="img-actions upload-attachment-button"
        >
          <v-icon>mdi-paperclip</v-icon>
          <br>
          <span v-if="isDragging"> {{ local.attachment.dropHeader }}</span>
          <span v-if="!isDragging"> {{ local.common.upload }}</span>
          <br>
          <span
            v-if="!isDragging"
            class="extension"
          >{{ local.attachment.acceptedExtensionMessage(acceptedTypes) }}</span>
        </label>
      </div>
    </v-col>

    <v-col
      v-for="(attachment , index) in formModel.AttachmentList"
      :key="index"
      cols="12"
    >
      <label> {{ local.common.attachments }}</label>
      <div class="d-block">
        <span class="attachment-btn">
          <v-icon class="icon">mdi-paperclip</v-icon>
          {{ attachment.FILENAME }}

          <button
            v-if="!formModel.viewMode"
            @click="removeFile()"
          >
            <v-icon class="icon">mdi-close</v-icon>
          </button>
          <button
            v-if="formModel.viewMode"
            @click="downloadFile()"
          >
            <v-icon class="icon">mdi-download</v-icon>
          </button>
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'AttachmentForm',
  components: {},
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({ AttachmentList: [] }),
    },
  },
  data() {
    return {
      isDragging: false,
      acceptedTypes: '.bmp, .jpg, .jpeg, .png, .pdf',
      reader: new FileReader(),
      attachmentObject: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    this.reader.onload = (e) => {
      this.updateFileBase64(e.target.result);
    };
  },
  mounted() {
  },
  methods: {
    inputFileChangeHandler(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.prepareFileObject(file);
    },
    updateFileBase64(file) {
      if (this.attachmentObject) {
        this.attachmentObject.attachmentBase64 = file;
        this.$set(this.formModel, 'AttachmentList', [this.attachmentObject]);
      }
    },
    prepareFileObject(file) {
      this.removeFile(); // reset file input value
      const attachmentKey = `${file.lastModified}${file.size}`;
      let validExtension = this.checkFileExtension(file);
      let validSize = this.checkFileESize(file);
      if (validExtension && validSize) {
        this.attachmentObject = {
          fileSize_Bytes: file.size,
          FILENAME: file.name,
          Title: file.type.match('image') ? 'File Name Image' : 'PDF File Name',
          fileObject: file,
          key: attachmentKey,
          attachmentBase64: null,
        };
        //this.$set(this.formModel, 'AttachmentList', [attachmentObject]);
        this.reader.abort(); // cancel the read operation if found
        this.reader.readAsDataURL(file);
      }
    },
    checkFileExtension(file) {
      let extension = '.' + file.name.split('.')
        .pop();
      if (!this.acceptedTypes.includes(extension)) {
        this.toaster.error(this.local.attachment.extensionError);
        this.resetFileInput();
        return false;
      }
      return true;
    },
    checkFileESize(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.toaster.error(this.local.attachment.sizeError);
        this.resetFileInput();
        return false;
      }
      return true;
    },
    resetFileInput() {
      if (this.$refs.attachmentFileInput) this.$refs.attachmentFileInput.value = '';
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (!file) return;
      this.prepareFileObject(file);
      this.isDragging = false;
    },
    removeFile() {
      this.attachmentObject = {};
      this.$set(this.formModel, 'AttachmentList', []);
      this.resetFileInput();
    },
    downloadFile() {
      if (this.formModel.AttachmentList && this.formModel.AttachmentList.length > 0) {
        var a = document.createElement('a'); //create <a>
        a.href = this.formModel.AttachmentList[0].attachmentBase64; //image Base64 Goes here
        a.download = this.formModel.AttachmentList[0].FILENAME; //file name Here
        a.click(); //downloaded file
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.attachment-container {
  width: 100%;
}
.dropzone-container {
  border: 2px dashed #d8d9e2;
  width: 100%;
  border-radius: 6px;
}
.img-actions {
  width: 100%;
  color: #252733;
  text-align: center;
  font-size: 20px;
  border-radius: 6px;
  color: #252733;
  cursor: pointer;
  ::v-deep .v-icon {
    color: inherit;
  }

  &.upload-attachment-button {
    display: block;
    // border: 2px dashed #f6f6f6;
    padding: 20px;
  }
  &:hover {
    // color: #fff;
    background-color: #a4a4a421;
    //border-color: #cfcfcf;
  }
}
input {
  width: 0;
  height: 0;
  font-size: 0;
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
  position: absolute;
}
.extension {
  font-size: smaller;
  color: slategray;
}
</style>
